
  var _styles = {
  "city_horizontal_text": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap"
  },
  "city_horizontal_text_item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "city_horizontal_text_card": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.90667rem"
  },
  "city_horizontal_text_card_text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "letterSpacing": 0,
    "fontWeight": "400",
    "textAlign": "center",
    "width": "1.41333rem"
  },
  "city_horizontal_text_divider": {
    "height": "0.4rem",
    "width": "0.04rem",
    "marginTop": 0,
    "marginRight": "0.01333rem",
    "marginBottom": 0,
    "marginLeft": "0.01333rem"
  }
};



  module.exports = _styles;
  